import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES, PAGE} from '../../../_config/strings';
import {Usuario} from '../../../_model/Usuario';
import { Cliente } from '../../../_model/Cliente';
import Swal from 'sweetalert2';
import {Subject} from 'rxjs/Subject';
import * as moment from 'moment';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import { ChatService } from '../../../_services/chat.service';

@Component({
  selector: 'app-movimientos-almacen',
  templateUrl: './movimientos-almacen.component.html',
  styleUrls: ['./movimientos-almacen.component.scss']
})

export class MovimientosAlmacenComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  PAGE: any;

  // array´s
  arrayMovimientosAlmacen = [];

  // fechaMovimiento = moment().format('MMMM Do YYYY, h:mm:ss a');
  fechaMovimiento = moment().format('DD-MMM-YYYY');
  fechaHora = moment().format('DD-MMM-YYYY');
  fechaYHora;

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
   }

  ngOnInit() {
    this.movimientosAlmacen();
  }

  movimientosAlmacen () {
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.movimientos,
      'GET',
      null
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 200 ) {
        this.arrayMovimientosAlmacen = response.Mensaje;
        this.arrayMovimientosAlmacen = this.arrayMovimientosAlmacen.reverse();
        // this.fechaMovimiento = moment(response.Mensaje.fecha).locale('es').format('MMMM Do YYYY, h:mm:ss a');
        // this.fechaMovimiento = moment(response.Mensaje.fecha).locale('es').format('LL');
        this.fechaMovimiento = response.Mensaje.fecha;
      }
      console.log( this.arrayMovimientosAlmacen );
      this.dtTrigger.next();
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/movimientos-almacen/movimientos-almacen.component.ts